import React from 'react'
import NoContent from "@/view/common/component/NoContent";
import {BoardData} from "@/service/BoardService";
import Icon from "@/view/common/component/Icon";
import BoardListItem from "@/view/board/BoardListItem";

export interface BoardParam {
    boardList: BoardData[],
    onReturn: () => void
}

const Board = (props: BoardParam) => {
    if(props.boardList.length === 0){
        return (
            <>
                <NoContent className='no-board-list mb-18px' notification='작성된 글이 없습니다' />
            </>
        )
    }else{
        return (
            <>
                <div className={'question-list'}>
                    {props.boardList.map((data,index) =>{
                        return <div key={index}>
                            <BoardListItem index={index}
                                           type={'boardDetail'}
                                           title={data.title}
                                           contents={data.content}
                                           detailProp={data}
                                           subTitle={data.regDt}
                                           heightClass={'h-88px'}
                                           nickName={data.writerNickName}
                                           onReturn={() => props.onReturn()}
                                           rightContent={<Icon divClass={'align-end'} iconClass={'next w-20px h-20px'}/>} />
                        </div>
                    })}
                </div>
            </>
        )
    }
}

export default Board;